<template>
  <b-card class="text-left rgpd">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="$t('dashboard.rgpd')" />
  </b-card>
</template>

<script>
  export default {
    name: 'RgpdCardComponent',
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  @include media-breakpoint-down(xs) {
    .rgpd {
      margin-bottom: 100px;
    }
  }
</style>
